<div class="row">
  <div class="col-12">
    <h4 (click)="collapseDeemedDividend841.toggle()"
        [attr.aria-expanded]="!isSectionDeemedDividend841Collapsed"
        aria-controls="deemedDividend841">
      Deemed Dividend 84.1
    </h4>

    <div #collapseDeemedDividend841="ngbCollapse" [(ngbCollapse)]="isSectionDeemedDividend841Collapsed">
      <div class="card table-result-card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'ACVT'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Augmentation du capital versé de toutes les actions de la société acheteuse
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.section84_1.totalIncreasePaidUpCapital | currencyCents | notAvailable }}</div>

              </div>
              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'CAA'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Contrepartie reçue autre que des actions
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.totalAmountOfNonShareConsideration | currencyCents | notAvailable }}</div>

              </div>

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'E'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Pour les actions vendues, le plus élevé du:
                </div>
              </div>


              <div class="table-result table-result-row table-result-row-indent-1">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'secondary'" [text]="'i'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Capital versé</div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredOptions.paidUpCapitalOfTransferredShares | currencyCents | notAvailable }}</div>
              </div>


              <div class="table-result table-result-row table-result-row-indent-1">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'secondary'" [text]="'ii'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Prix de base rajusté modifié
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.section84_1.modifiedAdjustedCostBase | currencyCents | notAvailable }}</div>
              </div>

              <div class="table-result table-result-row table-result-row-align-indent-0 table-result-row-calculation">
                <div class="table-result-col table-result-col-description text-end">
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                       [text]="'E'"></app-output-variable>
                  =
                  MAX(
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                                       [text]="'i'"></app-output-variable>
                  ,
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                                       [text]="'ii'"></app-output-variable>
                  )
                  = {{ propertyTransferredOptions.paidUpCapitalOfTransferredShares | currencyCents | notAvailable }}
                  + {{ propertyTransferredResults.section84_1.modifiedAdjustedCostBase| currencyCents | notAvailable }}
                  =
                </div>

                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.section84_1.deemedDividendElementE | currencyCents | notAvailable }}</div>
              </div>


              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'RCVT'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Réduction du capital versé selon 84.1(1)a) L.I.R
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.section84_1.reducedPaidUpCapital | currencyCents | notAvailable }}</div>

              </div>

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'DIV 84.1'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Dividende réputé selon 84.1(1)b) L.I.R.
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-description text-end">
                  (
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                       [text]="'ACVT'"></app-output-variable>
                  +
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                       [text]="'CAA'"></app-output-variable>
                  ) - (
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                       [text]="'E'"></app-output-variable>
                  +
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                       [text]="'RCVT'"></app-output-variable>
                  )
                  =
                  (
                  {{ propertyTransferredResults.section84_1.totalIncreasePaidUpCapital | currencyCents | notAvailable }}
                  +
                  {{ propertyTransferredResults.totalAmountOfNonShareConsideration | currencyCents | notAvailable }}
                  ) - (
                  {{ propertyTransferredResults.section84_1.deemedDividendElementE | currencyCents | notAvailable }}
                  +
                  {{ propertyTransferredResults.section84_1.reducedPaidUpCapital | currencyCents | notAvailable }}
                  )

                  =
                </div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.section84_1.deemedDividend | currencyCents | notAvailable }}</div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>